const getSiteProperties = (rootState) => rootState.ws.site.properties;

export default getSiteProperties;
